import { render, staticRenderFns } from "./RaceName.vue?vue&type=template&id=3bd69939&scoped=true&"
import script from "./RaceName.vue?vue&type=script&lang=js&"
export * from "./RaceName.vue?vue&type=script&lang=js&"
import style0 from "./RaceName.vue?vue&type=style&index=0&id=3bd69939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd69939",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VChip,VSpacer,VToolbarTitle})
